// extracted by mini-css-extract-plugin
module.exports = {"machine-list":"style_machine-list__2RVfx"};